import React from 'react';
import { Grid, Box, Typography, Paper } from '@mui/material';
import { MemberDistribution } from '../../../services/dashboardService';
import { useTranslation } from 'react-i18next';
import PeopleIcon from '@mui/icons-material/People';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import PersonIcon from '@mui/icons-material/Person';
import EmojiPeopleIcon from '@mui/icons-material/EmojiPeople';

interface MemberDistributionStatsProps {
  data: MemberDistribution;
}

/**
 * Composant pour afficher les statistiques de répartition des membres
 */
const MemberDistributionStats: React.FC<MemberDistributionStatsProps> = ({ data }) => {
  const { t } = useTranslation();

  const stats = [
    {
      label: t('dashboard:memberDistribution.activeMembers'),
      value: data.activeMembers,
      icon: <PeopleIcon sx={{ fontSize: 30, color: '#1976d2' }} />,
    },
    {
      label: t('dashboard:memberDistribution.vehiclesPerMember'),
      value: data.vehiclesPerMember.toFixed(1),
      icon: <DirectionsCarIcon sx={{ fontSize: 30, color: '#1976d2' }} />,
    },
    {
      label: t('dashboard:memberDistribution.regularDrivers'),
      value: data.regularDrivers,
      icon: <PersonIcon sx={{ fontSize: 30, color: '#1976d2' }} />,
    },
    {
      label: t('dashboard:memberDistribution.occasionalUsers'),
      value: data.occasionalUsers,
      icon: <EmojiPeopleIcon sx={{ fontSize: 30, color: '#1976d2' }} />,
    },
  ];

  return (
    <Grid container spacing={2}>
      {stats.map((stat, index) => (
        <Grid item xs={6} key={index}>
          <Paper
            sx={{
              p: 2,
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: 2,
            }}
            elevation={1}
          >
            <Box sx={{ mb: 1 }}>{stat.icon}</Box>
            <Typography variant="h5" component="div" align="center">
              {stat.value}
            </Typography>
            <Typography variant="body2" color="text.secondary" align="center">
              {stat.label}
            </Typography>
          </Paper>
        </Grid>
      ))}
    </Grid>
  );
};

export default MemberDistributionStats;